import React from 'react';
import { motion } from 'framer-motion';
import { reviewActions, workflowSteps } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpWorkflow() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-1985" data-mp="2xc0c36u3negl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1986" data-mp="2xap5kz99rsls">
        <motion.h2 {...fadeUp} className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight mb-14" data-id="element-1987" data-mp="2scw2wg76dgq9">
          How the platform works
        </motion.h2>

        <ol className="border-b border-line" data-id="element-1988" data-mp="2jc7q1otipmey">
          {workflowSteps.map(step => <motion.li key={step.number} {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line py-12" data-id="element-1989" data-mp="2eez73m0jpecn">
              <div className="lg:col-span-4 flex gap-5" data-id="element-1990" data-mp="clhzgicf0dhw">
                <span className="font-heading font-extrabold text-5xl text-teal leading-none w-10 shrink-0" data-id="element-1991" data-mp="7ngefrvfi43s">
                  {step.number}
                </span>
                <div data-id="element-1992" data-mp="1372831m9vwqe">
                  <h3 className="font-heading font-bold text-2xl text-ink-dark mb-4" data-id="element-1993" data-mp="13aq1m0rpwj54">
                    {step.title}
                  </h3>
                  <ul className="flex flex-wrap gap-2" aria-label="Tools used" data-id="element-1994" data-mp="taz4rsfops1v">
                    {step.tools.map(tool => <li key={tool} className="text-xs font-medium text-navy bg-surface-muted border border-line rounded px-2 py-1" data-id="element-1995" data-mp="y9ive6583s0k">
                        {tool}
                      </li>)}
                  </ul>
                </div>
              </div>

              <div className="lg:col-span-8" data-id="element-1996" data-mp="1h7v2znghktu1">
                <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1997" data-mp="1h6k2pxm9247o">{step.body}</p>

                {step.note && <p className="mt-6 border-l-2 border-green-soft pl-5 text-base text-ink-dark leading-relaxed" data-id="element-1998" data-mp="24vmkd5gvvx26">
                    {step.note}
                  </p>}

                {step.number === '3' && <div className="mt-6 bg-surface-muted rounded-lg p-6" data-id="element-1999" data-mp="2ell30hribam3">
                    <p className="text-ink-dark font-semibold mb-1" data-id="element-2000" data-mp="2ejiclwmfzfgu">
                      AI proposals remain proposals until approved.
                    </p>
                    <p className="text-ink-muted mb-4" data-id="element-2001" data-mp="25jvaf8lw25mq">Reviewers can:</p>
                    <ul className="flex flex-wrap gap-2" data-id="element-2002" data-mp="20m2146pagvi8">
                      {reviewActions.map(action => <li key={action} className="text-sm font-medium text-ink-dark bg-white border border-line rounded-md px-3 py-1.5" data-id="element-2003" data-mp="1vtsgn66y0nnc">
                          {action}
                        </li>)}
                    </ul>
                  </div>}
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}